import MapModule from "./modules/mapModule";
import HomePopup from "./modules/home-popup";
import TimelineSlider from "./modules/timeline-slider";
import history from "./utils/history";

const Map = new MapModule();
Map.init();

const HomePopupModule = new HomePopup();
HomePopupModule.init();

const Timeline = new TimelineSlider();
Timeline.init();


/* scroll from top video to sote content */
var scrollToFrontPageContent = $("#scrollToFrontPageContent");

scrollToFrontPageContent.on("click", function () {
    $(".home-main").addClass('is-activated');
});

if (history.get('ids')) {
    $(".home-main").addClass('is-activated');
}
/* end scroll from top video to sote content */

/* hide sidebar with articles list on site load */
var mapStoriesWrap = $(".map__storys-wrap");
mapStoriesWrap.hide();
/* end hide sidebar with articles list on site load */

/* time line navigation */
var timeline = $("#timeline");
var yearsLinks = timeline.find("a.years");
var yearsLinksActive = timeline.find("a.years.checked");
var yearPrev = $(".timeline-control.prev");
var yearNext = $(".timeline-control.next");
if (yearsLinksActive.next(".timeline-control").length) {
    yearNext.addClass("disabled");
} else if (yearsLinksActive.prev(".timeline-control").length) {
    yearPrev.addClass("disabled");
}
yearNext.on("click", function () {
    if (yearPrev.hasClass("disabled")) {
        yearPrev.removeClass("disabled");
    }
    var nextLink = $("a.years").get(yearsLinksActive.index());
    if (typeof (nextLink) !== "undefined") {
        nextLink.click();
    }
});
yearPrev.on("click", function () {
    if (yearNext.hasClass("disabled")) {
        yearNext.removeClass("disabled");
    }
    var prevLink = $("a.years").get(yearsLinksActive.index() - 2);
    if (typeof (prevLink) !== "undefined") {
        prevLink.click();
    }
});
/* end time line navigation */
